import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { INSGridConfig } from '@norfolk-southern/accessns-components';
import { ColDef, GridOptions } from 'ag-grid-community';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { ShortLineConstants } from '@ruby/configs/short-line.constants';
import { IShortLineCustomerContacts } from '@ruby/modules/short-line-profile/models/short-line-profile.interface';
import { SlCustomersContactContainer } from '@ruby/shared/dialogs/short-line/containers/sl-customers-contact/sl-customers-contact.container';

@Component({
  selector: 'ng-sl-customers',
  templateUrl: './sl-customers.component.html',
  styleUrls: ['./sl-customers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlCustomersComponent {
  @Input() canEdit!: boolean;
  @Input() canView!: boolean;
  @Input() isAdmin!: boolean;
  @Input() loading!: boolean;
  @Input() data!: Array<IShortLineCustomerContacts>;
  @Input() isProfile!: boolean;
  columnDefs: Array<ColDef> = ShortLineConstants.columnDefSLCustomers;
  config: INSGridConfig = {
    hide: {
      header: true
    }
  };
  options: GridOptions = {
    rowHeight: 30,
    overlayNoRowsTemplate: NSCommonConstants.noResultsFoundMessage
  };

  constructor(private dialogSvc: MatDialog) { }

  /**
   * Create Contact
   *
   * @summary Opens the dialog to create new contact
   * @returns void
   */
  createContact(): void {
    this.dialogSvc.open(SlCustomersContactContainer, { width: '50%' });
  }
}
